import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconHeart } from "../../Experimental__Icon/icons/Experimental__IconHeart";
import { Icon } from "../";
/**
 * @deprecated The name IconHeartAlt is deprecated and will be archived soon. Use IconHeart instead.
 */

export function IconHeartAlt(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status !== encoreContextStatus.deprecated) {
    return /*#__PURE__*/React.createElement(Experimental__IconHeart, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M21.5 9a5.49 5.49 0 00-8.67-4.49 1.44 1.44 0 01-1.65 0A5.49 5.49 0 002.5 9c0 3.5 5.86 8.89 8.37 11.4a1.59 1.59 0 002.25 0c2.52-2.51 8.38-7.9 8.38-11.4z\" fill=\"none\" stroke=\"#181818\"/>"
    }
  }));
}
export default IconHeartAlt;